import React from "react";

import Button from "@/components/Button";
import { useAdminStore } from "@/stores/adminStore";
import { prepareHeaders } from "@/utils";
import cincolabdataEndpoints from "@/utils/cincolabdata.endpoints";

interface AdminHeaderProps {
  setError: (error: string) => void;
  onAfterLogout: () => void;
}

const AdminHeader = ({ setError, onAfterLogout }: AdminHeaderProps) => {
  const adminStore = useAdminStore();

  const onLogout = async () => {
    setError("");

    if (!adminStore.adminToken) {
      return setError("response.error");
    }

    const response = await fetch(cincolabdataEndpoints.auth.logout, {
      method: "POST",
      headers: {
        ...prepareHeaders(),
        "x-cinco-token": adminStore.adminToken,
      },
      mode: "cors",
      redirect: "follow",
    });
    const errorData = await response.json();

    if (!response.ok) {
      setError(errorData.error || "Logout failed");
      return;
    }

    onAfterLogout();
  };

  return (
    <div className="w-full flex justify-between mb-10">
      <Button
        className="pr-2 pl-2 min-w-[150px] text-xs"
        type="button"
        design="outline-blue"
        onClick={onLogout}
      >
        Logout
      </Button>
      <div className="flex flex-row justify-center items-center gap-4">
        <p className="text-dark-blue font-bold text-center text-l">
          {adminStore.adminUser?.name}
        </p>
        <div className="w-24 rounded-full bg-white w-[42px] h-[42px] overflow-hidden">
          <img
            src={adminStore.adminUser?.image ?? "/img/avatar.png"}
            alt="Avatar"
          />
        </div>
      </div>
    </div>
  );
};

export default AdminHeader;
